import resultFactory from '~/utils/resultFactory'

/**
 @since 2021-12-03
 @author Jaeuk Ryu <wj_tams_dev02>
 */

export const state = () => ({
  RadiusSettingUrl: '/api/sm/auth/radius-cm', // RADIUS 설정 URL
  RadiusSyncUrl: '/api/sm/auth/radius-cm/sync', // RADIUS 사용여부 설정 URL
  RadiusUrl: '/api/sm/auth', // RADIUS URL
  defaultId: -1, // 설정 추가용 ID
  settingDataList: [], // 설정 데이터 리스트
  authServerDataList: [], // RADIUS 조회 리스트

  // radiusdServerResult: 'OK', // 서버 추가시 중복 테스트 용도
  selectedStoreItem: {} // 수정중인 항목 모든탭 동일
})

export const mutations = {
  clearStore: (state) => {
    state.defaultId = -1
    state.settingDataList = [] // 설정 데이터 리스트
    state.authServerDataList = [] // RADIUS 조회 리스트
    state.selectedStoreItem = []
  },
  clearServerDataList: (state) => {
    state.authServerDataList = [] // RADIUS 조회 리스트
  },
  getDefaultId: (state, data) => {
    state.defaultId = data.authsvr_radius_cm_id
  },

  // 서버 Reference 조회
  // getServerReference: (state, item) => { // need to check
  //   // state.serverReference = item
  //   let serverRef = _.clone(state.serverReference)
  //   const keys = Object.keys(state.serverReference)
  //   _.forEach(keys, key => {
  //     if (item[key]) {
  //       serverRef[key] = item[key]
  //     } else {
  //       serverRef[key] = []
  //     }
  //   })
  //   state.serverReference = serverRef
  // },

  setSelectedStoreItem: (state, item) => {
    state.selectedStoreItem = item
  },
  getSettingDataList: (state, item) => {
    state.settingDataList = _.cloneDeep(item)
  },

  editAuthServerListDataAction: (state, data) => {
    state.settingDataList = _.map(state.settingDataList, (item) => {
      if (item.authsvr_radius_cm_id === data.authsvr_radius_cm_id) {
        item = _.cloneDeep(data)
        // item.protocolName = getProtocolName(item)
      }
      return item
    })
  },

  authServerHeaderMutation: (state, data) => {
    state.settingDataList = _.map(state.settingDataList, (item) => {
      item.authsvr_radius_cm_sync_yn = data
      return item
    })
  },

  delSettingDataList: (state, item) => {
    _.forEach(item, (p) => {
      const idx = _.findIndex(state.settingDataList, {authsvr_radius_cm_id: p.authsvr_radius_cm_id})
      if (idx >= 0) {
        state.settingDataList.splice(idx, 1)
      }
    })
  },

  getRadiusDataList: (state, item) => {
    state.authServerDataList = _.cloneDeep(item)
  },
  addRadiusData: (state, item) => {
    state.authServerDataList.push(_.cloneDeep(item))
  },
  editRadiusData: (state, item) => {
    const idx = _.findIndex(state.authServerDataList, {authsvr_radius_id: item.authsvr_radius_id})
    state.authServerDataList.splice(idx, 1, item)
  },
  delRadiusDataList: (state, item) => {
    _.forEach(item, (p) => {
      const idx = _.findIndex(state.authServerDataList, {authsvr_radius_id: p.authsvr_radius_id})
      if (idx >= 0) {
        state.authServerDataList.splice(idx, 1)
      }
    })
  }
}

export const actions = {
  async getSettingDataList ({commit, state}) { // 인증 서버 설정 조회
    try {
      const data = await this.$axios.$get(state.RadiusSettingUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getSettingDataList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async addSettingData ({commit, state}, payload) { // 인증 서버 통합 설정 추가
    try {
      const data = await this.$axios.$put(state.RadiusSettingUrl, payload, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async editSettingData ({commit, state}, payload) { // 인증 서버 통합 편집
    try {
      const data = await this.$axios.$put(state.RadiusSettingUrl, payload, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async delSettingDataList ({commit, state}, payload) {
    let isMulty = false
    const idList = []
    const delList = []
    if (payload.length > 1) {
      isMulty = true
    }
    payload.forEach((item) => {
      idList.push({'authsvr_radius_cm_id': item.authsvr_radius_cm_id})
      delList.push(item.authsvr_radius_cm_id)
    })
    try {
      const data = isMulty ? await this.$axios.$delete(state.RadiusSettingUrl, {data: {items: delList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.RadiusSettingUrl}/${payload[0].authsvr_radius_cm_id}`)

      return resultFactory(commit, {length: idList.length, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },

  async editAuthServerDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(state.RadiusSyncUrl, payload, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async editAuthServerListDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(`${state.RadiusSyncUrl}/${payload[0].authsvr_radius_cm_id}`, _.pick(payload[0], ['authsvr_radius_cm_sync_yn']), {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },

  async getDefaultId ({commit, state}) { // 설정 추가용 ID 조회
    try {
      const data = await this.$axios.$post(state.RadiusSettingUrl, null, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'getDefaultId', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // RADIUS //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getRadiusDataList ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.RadiusUrl}/${state.defaultId}/radius`)
      return resultFactory(commit, {length: null, data: data, action: 'getRadiusDataList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async addRadiusData ({commit, state, dispatch}, payload) { // 인증 서버 추가.
    const param = makePayload(_.cloneDeep(payload))
    try {
      const data = await this.$axios.$post(`${state.RadiusUrl}/${state.defaultId}/radius`, param)
      return resultFactory(commit, {length: null, data: data, action: 'addRadiusData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async editRadiusData ({commit, state, dispatch}, payload) {
    const param = makePayload(_.cloneDeep(payload))
    try {
      const data = await this.$axios.$put(`${state.RadiusUrl}/${state.defaultId}/radius/${payload.authsvr_radius_id}`, param)
      return resultFactory(commit, {length: null, data: data, action: 'editRadiusData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async delRadiusDataList ({commit, state}, payload) {
    let isMulty = false
    const idList = []
    const delList = []
    if (payload.length > 1) {
      isMulty = true
    }
    payload.forEach((item) => {
      idList.push({'authsvr_radius_id': item.authsvr_radius_id})
      delList.push(item.authsvr_radius_id)
    })
    try {
      const data = isMulty ? await this.$axios.$delete(`${state.RadiusUrl}/${state.defaultId}/radius`, {data: {items: delList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.RadiusUrl}/${state.defaultId}/radius/${payload[0].authsvr_radius_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: 'delRadiusDataList', param: idList})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
  // RADIUS //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}

function makePayload (param) {
  const serverKeyMap = {
    name: 'radius_svr_name',
    ip: 'radius_svr_ip',
    passwd: 'radius_svr_passwd',
    auth_port: 'radius_svr_auth_port',
    accnt_port: 'radius_svr_accnt_port',
    radius_svr_id: 'radius_svr_id'
  }
  const server = []
  _.forEach(param.servers, (item) => {
    server.push(_.omit(_.mapKeys(item, (value, key) => {
      return serverKeyMap[key]
    }), ['undefined', 'itemIndex']))
  })
  param.servers = server

  const payloadKeyMap = {
    authsvr_radius_id: 'authsvr_radius_id',
    name: 'authsvr_radius_name',
    auth_type: 'authsvr_radius_auth_type',
    auth_only: 'authsvr_radius_auth_only',
    desc: 'authsvr_radius_desc',
    tm_out: 'authsvr_radius_tm_out',
    retry_cnt: 'authsvr_radius_retry_cnt',
    servers: 'servers'
  }
  return _.omit(_.mapKeys(param, (value, key) => {
    return payloadKeyMap[key]
  }), ['undefined'])
}
